import { FC } from 'react';

type Props = {
	className?: string;
};

const Calendar_04_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M14.7993 2V3.60002M5.19922 2V3.60002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.39844 10.1944C2.39844 6.7086 2.39844 4.96565 3.40014 3.88273C4.40185 2.7998 6.01407 2.7998 9.23851 2.7998H10.7585C13.983 2.7998 15.5952 2.7998 16.5969 3.88273C17.5986 4.96565 17.5986 6.7086 17.5986 10.1944V10.6053C17.5986 14.0912 17.5986 15.8341 16.5969 16.9171C15.5952 18 13.983 18 10.7585 18H9.23851C6.01407 18 4.40185 18 3.40014 16.9171C2.39844 15.8341 2.39844 14.0912 2.39844 10.6053V10.1944Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.79688 6.7998H17.197'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Calendar_04_Icon;
